/**
 * Role-code constants mirroring each backend module's own ROLES object, so
 * every page checks the same literal strings the API gates on instead of
 * re-typing them:
 *   M11 packages/modules/m11-egp/src/routes/shared.ts
 *   M12 packages/modules/m12-trade-investment/src/constants.ts
 *   M14 packages/modules/m14-licensing/src/constants.ts
 */
export const M11_ROLES = {
  PROCUREMENT_OFFICER: 'PROCUREMENT_OFFICER',
  EVALUATOR: 'EVALUATOR',
  TENDER_BOARD: 'TENDER_BOARD',
  NPTB_OVERSIGHT: 'NPTB_OVERSIGHT',
} as const;

export const M12_ROLES = {
  TRADE_OFFICER: 'TRADE_OFFICER',
  INVESTMENT_FACILITATOR: 'INVESTMENT_FACILITATOR',
} as const;

export const M14_ROLES = {
  LICENSING_OFFICER: 'LICENSING_OFFICER',
  SENIOR_LO: 'SENIOR_LO',
  BOARD_SECRETARIAT: 'BOARD_SECRETARIAT',
  ENFORCEMENT_OFFICER: 'ENFORCEMENT_OFFICER',
} as const;

export function hasAnyRole(roles: string[] | undefined, ...check: string[]): boolean {
  if (!roles) return false;
  return check.some((r) => roles.includes(r));
}
